import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      margin: "60px 0"
    },
    header: {
      background: theme.palette.gardient.medium,
      display: "flex",
      alignItems: "center",
      borderTopRightRadius: 6,
      borderTopLeftRadius: 6
    },
    title: {
      color: "white",
      padding: "14px 24px"
    },
    subHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "24px 0"
    },
    subTitle: {
      color: theme.palette.grey[900]
    },
    itemContainer: {
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      borderRadius: 12,
      marginBottom: 20,
      display: "flex",
      flexWrap: "wrap",
      padding: "24px 20px"
    },
    itemWrapper: {
      paddingLeft: "4rem",
      flex: 1
    },
    itemTitle: {
      color: theme.palette.info.dark,
      fontSize: 16,
      lineHeight: "24px",
      fontWeight: 700
    },
    itemLabel: {
      fontWeight: 700,
      marginBottom: 10
    },
    gridContainer: {
      display: "grid",
      gridTemplateAreas: `
      "item1 item2 item3 item4 item5 item6"
      "item7 item8 item8 item9 item10 item10"
      `,
      gridTemplateColumns: "0.6fr 0.6fr 0.5fr 0.5fr 0.5fr 0.5fr",
      columnGap: 16,
      rowGap: 16,
      marginTop: 24
    },
    btnContainer: {
      textAlign: "right",
      "& button": {
        background: "none",
        border: "none",
        padding: 0,
        display: "inline-flex"
      }
    },
    btnWrapper: {
      padding: "24px 0",
      "& div": {
        marginBottom: 18,
        cursor: "pointer"
      }
    },
    btnDelete: {
      padding: "9px 32px"
    },
    item1: {
      gridArea: "item1",
      "& .MuiFormControl-root": {
        width: "100%"
      }
    },
    item2: {
      gridArea: "item2"
    },
    item3: {
      gridArea: "item3"
    },
    item4: {
      gridArea: "item4"
    },
    item5: {
      gridArea: "item5"
    },
    item6: {
      gridArea: "item6"
    },
    item7: {
      gridArea: "item7",
      "& .MuiFormControl-root": {
        width: "100%"
      },
      "& input": {
        padding: "9px 16px !important"
      },
      "& .MuiOutlinedInput-adornedEnd": {
        paddingRight: 0
      },
      "& .MuiIconButton-root": {
        border: "none",
        background: "transparent"
      },
      "& .MuiIconButton-root:hover": {
        color: theme.palette.info.dark,
        borderColor: theme.palette.info.dark
      }
    },
    item8: {
      gridArea: "item8"
    },
    item9: {
      gridArea: "item9",
      "& button": {
        maxHeight: 39
      }
    },
    item10: {
      gridArea: "item10"
    },
    flex: {
      display: "flex"
    },
    under: {
      width: "50%",
      height: 39,
      background: theme.palette.grey[200],
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontStyle: "italic",
      color: theme.palette.grey[900]
    },
    over: {
      width: "50%",
      height: 39,
      background: theme.palette.grey[300],
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontStyle: "italic",
      color: theme.palette.grey[900]
    },
    normalText: {
      fontWeight: "normal"
    },
    actions: {
      color: theme.palette.grey[600]
    }
  }),
  { name: "ProductDetails" }
);

export default useStyles;
